import cn from 'classnames'
import { TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'
import { FC, useCallback } from 'react'

import { useFormField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { IToggleItemState } from './components/toggleItem/models/IToggleItemState'
import { ToggleItem } from './components/toggleItem/ToggleItem'

import styles from './PeriodSelector.module.scss'

const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4']

interface IPeriodSelectorProps {
  initialValue?: string[]
  className?: string
  isDisabled?: boolean
  isRequired?: boolean
  formKey: string
  showLabel?: boolean
}

export const PeriodSelector: FC<IPeriodSelectorProps> = ({
  initialValue = [],
  isDisabled,
  isRequired,
  formKey,
  showLabel = false,
}) => {
  const {
    value: selectedQuarters,
    handleChange,
    validationMessage,
  } = useFormField<string[]>({
    defaultValue: initialValue,
    formKey,
    field: 'period',
    isRequired,
    isDisabled,
    validationType: ValidationType.ONCHANGE,
  })

  const handleToggleQuarter = useCallback(
    (state: IToggleItemState) => {
      if (state.isActive) {
        handleChange([...selectedQuarters, state.value].sort())
      } else {
        handleChange(selectedQuarters.filter((q) => q !== state.value))
      }
    },
    [selectedQuarters, handleChange]
  )

  return (
    <div className={styles.root}>
      {showLabel && (
        <div className={styles.label}>
          <Translation
            text={TRANSLATION_KEYS.keyInitiativeEditor.keyInitiativeAndPeriodFieldGroup.period}
          />
        </div>
      )}
      <Tooltip disabled={!validationMessage} tipContent={() => <>{validationMessage}</>}>
        <div className={cn(styles.quartersContainer, { [styles.invalid]: validationMessage })}>
          {QUARTERS.map((quarter) => (
            <ToggleItem
              key={quarter}
              buttonClassName={styles.quarterButton}
              value={quarter}
              isActive={selectedQuarters.includes(quarter)}
              isDisabled={isDisabled}
              onClick={handleToggleQuarter}
            />
          ))}
        </div>
      </Tooltip>
    </div>
  )
}
